import './assets/css/main.scss'
import './assets/js/iconfont'

import { createApp } from 'vue'
// 引入 pinia
import store from './stores'
// 登录鉴权
import './permission'

import App from './App.vue'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { useUserInfoStore } from './stores/modules/user'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store)

// 组织动态路由
const userStore = useUserInfoStore()
userStore.setAsyncRoutes()
app.use(router)

app.mount('#app')
